import React from 'react';

export default function OffboardingCoupleIcon(props) {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <path
        d='M12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8ZM12 16C15.8365 16 19 18.6815 19 22.0667C19 22.5821 18.5774 23 18.0562 23H5.94382C5.42256 23 5 22.5821 5 22.0667C5 18.6815 8.16352 16 12 16ZM25.8066 10.4697L25.7298 10.4025C25.4358 10.1788 25.0144 10.2012 24.7459 10.4697L24.6788 10.5465C24.4551 10.8404 24.4774 11.2618 24.7459 11.5303L25.135 11.92L21 11.9209C20.4477 11.9209 20 12.3686 20 12.9209C20 13.4731 20.4477 13.9209 21 13.9209L25.184 13.92L24.9436 14.1613L24.8765 14.2381C24.6527 14.5321 24.6751 14.9535 24.9436 15.222C25.2365 15.5149 25.7113 15.5149 26.0042 15.222L28.2816 12.9447L25.8066 10.4697Z'
        fill='currentColor'
      />
    </svg>
  );
}
